import React from "react";
import { contactData } from "./data";
import Lottie from "lottie-react";
import contact from "../../assets/animation/contact1.json";

function ContactHeader() {
  const { title, heading, subheading } = contactData;
  return (
    <section className="h-[90%] w-full mb-0 lg:mb-[50px]">
      <div
        className="mx-auto text-center p-0 lg:pt-[100px] h-[25%] relative z-[-1]"
        data-aos="fade-down"
        data-aos-delay="400"
      >
        <p className="font-bold lg:leading-[3.5rem] lg:text-4xl text-lg px-0 text-cyan-900">
          {heading}
        </p>
        <p className="font-bold lg:w-[45%] text-lg  text-cyan-700 font-serif   my-5 px-0 mx-auto">
          {subheading}
        </p>
      </div>
      <section className="flex lg:flex-row h-[60%] flex-col items-center justify-between mx-auto">
        <article
          className="lg:w-[50%] w-full"
          data-aos="fade-right"
          data-delay-aos="600"
        >
          <Lottie animationData={contact} loop={true} />
        </article>
        <article
          className="lg:w-[50%] w-full flex items-center p-6 "
          data-aos="fade-left"
          data-delay-aos="400"
        >
          <div className="gap-y-4">
            <p className="text-2xl lg:text-5xl my-5 font-bold text-cyan-700 hover:text-cyan-800">
              {title.one}
            </p>
            <p className="lg:text-5xl text-2xl my-5 font-bold text-cyan-700 hover:text-cyan-800">
              {title.two}
            </p>
            <p className="lg:text-5xl text-2xl my-5 font-bold text-cyan-700 hover:text-cyan-800">
              {title.three}
            </p>
          </div>
        </article>
      </section>
    </section>
  );
}

export default ContactHeader;
